"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_STATUS_CAMPANA_MAP = exports.SORTABLE_VIEW_STATUS_CAMP_COLUMNS_MAP = void 0;
const sms_saliente_1 = require("./sms-saliente");
exports.SORTABLE_VIEW_STATUS_CAMP_COLUMNS_MAP = {
    id: 'camp_id',
    fecha: 'camp_fecha_creacion',
    cuenta: 'servicio',
    campana: 'camp_nombre',
    dias: 'dias',
    horas: 'horas',
    tipo_servicio: 'tipo_envio',
    cantidad_sms: 'total_sms',
    cantidad_pendientes: 'total_pendientes',
    cantidad_pausados: 'total_pausados',
    cantidad_cancelados: 'total_cancelados',
};
exports.ALLOWED_STATUS_CAMPANA_MAP = {
    [sms_saliente_1.ESTATUS_SMS_SALIENTE.CANCEL]: sms_saliente_1.ESTATUS_SMS_SALIENTE.CANCEL,
    [sms_saliente_1.ESTATUS_SMS_SALIENTE.PENDIENTE]: sms_saliente_1.ESTATUS_SMS_SALIENTE.PENDIENTE,
    [sms_saliente_1.ESTATUS_SMS_SALIENTE.PAUSED]: sms_saliente_1.ESTATUS_SMS_SALIENTE.PAUSED,
};
